import React from 'react'

import { IconKey } from 'components/IconLink/iconMap'

import { Item } from '../../styles/Item'
import { StyledIconLink } from './styles/StyledIcon'

interface Props {
  icon: IconKey
  onClick?: () => void
  link?: string
  isEnabled?: boolean
  label?: string
  shouldRender?: boolean
}

export function IconItem({ onClick, isEnabled, link, icon, label, shouldRender = true }: Props) {
  if (!shouldRender) {
    return null
  }

  return (
    <Item
      onClick={onClick}
      isActive={isEnabled}
      data-testid={icon}
    >
      <StyledIconLink
        isEnabled={!!isEnabled}
        label={label?.replace(/_/g, ' ') || ''}
        icon={icon}
        link={link}
      />
    </Item>
  )
}
